import React from 'react';
import { useTranslation } from 'react-i18next';

interface PropertiesTabProps {
  assignedProperties: any[];
}

const PropertiesTab: React.FC<PropertiesTabProps> = ({
  assignedProperties = [],
}) => {
  const { t } = useTranslation();

  return (
    <div className="card-body">
      <h6 className="mb-4">{t('developers.addEdit.pageTexts.form.propertiesTab.title')}</h6>

      {assignedProperties.length === 0 ? (
        <div className="text-center text-muted py-5">
          <i className="ri-building-line fs-1 mb-3 d-block opacity-50"></i>
          <p>{t('developers.addEdit.pageTexts.form.propertiesTab.noPropertiesAssigned')}</p>
        </div>
      ) : (
        <div className="row row-cols-1 row-cols-md-3 g-4">
          {assignedProperties.map((item: any) => {
            const property = item.property;
            if (!property) return null;
            
            return (
              <div className="col" key={property.id || item.id}>
                <div className="card h-100 border shadow-none">
                  <div style={{ height: '200px' }} className="rounded-top position-relative overflow-hidden">
                    {property.primary_image ? (
                      <img
                        src={property.primary_image}
                        className="card-img-top h-100 w-100 object-fit-cover"
                        alt={property.name}
                        onError={(e) => {
                            (e.target as HTMLImageElement).onerror = null; 
                            (e.target as HTMLImageElement).src = ''; 
                            (e.target as HTMLImageElement).classList.add('d-none');
                            (e.target as HTMLImageElement).nextElementSibling?.classList.remove('d-none');
                        }}
                      />
                    ) : null}
                     <div className={`h-100 w-100 bg-light d-flex align-items-center justify-content-center text-muted ${property.primary_image ? 'd-none' : ''}`}>
                        <i className="ri-image-line fs-1"></i>
                     </div>
                  </div>
                  <div className="card-body p-3">
                    <h5 className="card-title text-truncate mb-1" title={property.name}>{property.name}</h5>
                    <p className="card-text text-muted small mb-2">{property.code}</p>
                    
                    <div className="d-flex justify-content-between align-items-center">
                        <span className={`badge ${property.is_active ? 'bg-label-success' : 'bg-label-secondary'}`}>
                            {property.is_active ? t('common.status.active') : t('common.status.inactive')}
                        </span>
                        {property.construction_status && (
                             <span className="badge bg-label-info text-capitalize">
                                {property.construction_status.replace('_', ' ')}
                             </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PropertiesTab;
